
import React from 'react';
import BaseModalComponent from './BaseModal';
import SelectAsync from 'react-select/async';
//to use history.push
import { withRouter } from 'react-router-dom';
import Uploader from 'react-images-upload';

class SpecialPerson extends BaseModalComponent {
  constructor(props) {
    var subModuleName = 'persons';
    if (props.isMain == true) subModuleName = 'persons_main';

    super(props, subModuleName , props.personId, props.ParentComponent);

    this.state.subModuleName = subModuleName;
    this.setProps(props);
    this.onDropPic = this.onDropPic.bind(this);
    this.state.remove = false;
  }
  componentDidMount() {
    if (this.state.id_to_edit==null || this.state.id_to_edit==0)
      this.openNewForm();
    else
      this.openModifyForm();//this.state.id_to_edit
  }
  componentWillReceiveProps(props){
    var subModuleName = 'persons';
    if (props.isMain == true) subModuleName = 'persons_main';
    this.state.subModuleName = subModuleName;

    this.setProps(props);
    this.onDropPic = this.onDropPic.bind(this);
    this.state.id_to_edit = props.Id;
    if (this.state.id_to_edit==null || this.state.id_to_edit==0)
      this.openNewForm();
    else
      this.openModifyForm();//this.state.id_to_edit
  }
  loadAffilationsOptions(inputValue, callback){
    setTimeout(() => {
      fetch("/api/organ/ajax/realobjects/", {
        method: "post",
        body: JSON.stringify({ "term": inputValue , parent_id: this.state.form_data.legal.role_id }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(records => {
        let items = [];
        records.map(_record => items.push({ value: _record.object_id, label: _record.title }));
        callback(items);
      })
  
    }, 50);
  }
  loadUniversityOptions(inputValue, callback){
    setTimeout(() => {
      fetch("/api/organ/ajax/universites/",{
        method: "post",
        body: JSON.stringify({"term":inputValue}),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json())
      .then(records =>{
        let items = [];
        records.map(_record => items.push({ value: _record.person_id, label: _record.name}));
        callback(items);
      })
      
    }, 50);
  }
  onDropPic(picture) {
    if (picture.length === 0) {
      return;
    }

    let reader = new FileReader();
    let file = picture[0];

    reader.onloadend = () => {
      this.state.form_data.record.pic = reader.result;
    }
    reader.readAsDataURL(file)
  }
  setProps(props){
    this.state.personId = props.personId;
  }
  setNewPerson(e,field){
    this.state.form_data.record[field] = e.target.value;
  }
  openNewForm() {
    this.lockScreen();
    this.setState({ id_to_edit: 0 });
    var get_url = '/api/organ/' + this.state.subModuleName + '/';
    fetch(get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": "new",
        "extra_fields":this.state.extra_fields
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(form_data => {
      this.setState({ form_data });
      this.unLockScreen();
    }
    ).catch(err=>{
      this.showToast("خطایی در نمایش اطلاعات پیش آمده است.","danger");
      this.unLockScreen();
    });
  }
  openModifyForm() {
    this.lockScreen();
    //this.setState({ id_to_edit: id });
    var get_url = '/api/organ/' + this.state.subModuleName + '/';
    fetch(get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": "get",
        "id": this.state.id_to_edit,
        "subModuleName": this.state.subModuleName,
        "extra_fields":this.state.extra_fields
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(form_data => {
      this.setState({ form_data });
      this.unLockScreen();
    }).catch(err=>{
        this.showToast('خطایی در نمایش اطلاعات رخ داده است.','danger');
        this.unLockScreen();
    });
  }
  saveForm(op='') {
    if (this.isNull(this.state.form_data.record.special_person_id)){
      if (this.state.form_data.record.fname == '')
      {
        this.showToast("لطفا نام را وارد نمایید.","warning");
        return;
      }
      if (this.state.form_data.record.lname == '')
      {
        this.showToast("لطفا نام خانوادگی را وارد نمایید.","warning");
        return;
      }
      if (this.state.form_data.record.fname_en == '')
      {
        this.showToast("لطفا نام لاتین را وارد نمایید.","warning");
        return;
      }
      if (this.state.form_data.record.lname_en == '')
      {
        this.showToast("لطفا نام خانوادگی لاتین را وارد نمایید.","warning");
        return;
      }
      if (this.state.form_data.record.email == '')
      {
        this.showToast("لطفا آدرس ایمیل را وارد نمایید.","warning");
        return;
      }
    }
    this.lockScreen();
    let type = "add";
    if (this.state.id_to_edit == 0)
      type = "add";
    else
      type = "edit";

    fetch(this.state.get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": type,
        "form": this.state.form_data.record,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((resualt) => {
      this.unLockScreen();
      if (resualt.status == 1) {
        this.showToast('اطلاعات با موفقیت ذخیره شد.','success');
        this.go("/persons/");
      }
      else
      {
        if (resualt.message === undefined)
        this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
        else
        this.showToast(resualt.message,'warning');
      }
    })
    .catch(err=>{
      this.unLockScreen();
      this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
    });
  }
  remove() {
    this.lockScreen();
    fetch(this.state.get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": "remove",
        "form": this.state.form_data.record,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((resualt) => {
      this.unLockScreen();
      if (resualt.status == 1) {
        this.showToast('اطلاعات با موفقیت حذف شد.','success');
        this.go("/persons/");
      }
      else
      {
        if (resualt.message === undefined)
        this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
        else
        this.showToast(resualt.message,'warning');
      }
    })
    .catch(err=>{
      this.unLockScreen();
      this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
    });
  }
  renderBody() {
    return (<div className="row">
      <div className="box box-info">
        <div className="form-horizontal">
          <div className="box-body">
            <div className="col-md-4">
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام: {this.state.form_data.record.RealPerson.fname}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام*</label>
                  <div className="col-sm-12">
                    <input onChange={e => this.setNewPerson(e, 'fname')} defaultValue={this.state.form_data.record.fname} type="text" className="form-control" placeholder="نام" />
                  </div>
                </div>
              }
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام خانوادگی: {this.state.form_data.record.RealPerson.lname}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام خانوادگی*</label>
                  <div className="col-sm-12">
                    <input onChange={e => this.setNewPerson(e, 'lname')} defaultValue={this.state.form_data.record.lname} type="text" className="form-control" placeholder="نام خانوادگی" />
                  </div>
                </div>
              }
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام لاتین: {this.state.form_data.record.RealPerson.fname_en}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام لاتین*</label>
                  <div className="col-sm-12">
                    <input onChange={e => this.setNewPerson(e, 'fname_en')} defaultValue={this.state.form_data.record.fname_en} type="text" className="form-control" placeholder="نام لاتین" />
                  </div>
                </div>
              }
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام خانوادگی لاتین: {this.state.form_data.record.RealPerson.lname_en}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام خانوادگی لاتین*</label>
                  <div className="col-sm-12">
                    <input onChange={e => this.setNewPerson(e, 'lname_en')} defaultValue={this.state.form_data.record.lname_en} type="text" className="form-control" placeholder="نام خانوادگی لاتین" />
                  </div>
                </div>
              }
            </div>

            <div className="col-md-4">
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">ایمیل: {this.state.form_data.record.RealPerson.email}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">ایمیل*</label>
                  <div className="col-sm-12">
                    <input onChange={e => this.setNewPerson(e, 'email')} defaultValue={this.state.form_data.record.email} type="text" className="form-control" placeholder="ایمیل" />
                  </div>
                </div>
              }
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">موبایل: {this.state.form_data.record.RealPerson.mobile}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">موبایل</label>
                  <div className="col-sm-12">
                    <input onChange={e => this.setNewPerson(e, 'mobile')} defaultValue={this.state.form_data.record.mobile} type="text" className="form-control" placeholder="موبایل" />
                  </div>
                </div>
              }
              {!this.isNull(this.state.form_data.record.special_person_id) ?
                <div className="form-group">
                  <label className="col-sm-12 control-label">جنسیت: {this.enumString(this.state.form_data.record.RealPerson.gender,"gender")}</label>
                </div>
              :
                <div className="form-group">
                  <label className="col-sm-12 control-label">جنسیت</label>
                  <div className="col-sm-12">
                    <select className="form-control" defaultValue={this.state.form_data.record.gender} onChange={(e) => { this.setNewPerson(e, 'gender') }}>
                      <option value="1">آقا</option>
                      <option value="2">خانم</option>
                    </select>
                  </div>
                </div>
              }
              <div className="form-group">
                <label className={this.isNull(this.state.form_data.record.special_person_id) ? "col-sm-12 control-label" : "col-sm-2 control-label"}>سمت*</label>
                <div className={this.isNull(this.state.form_data.record.special_person_id) ? "col-sm-12" : "col-sm-10"}>
                  <SelectAsync
                    isMulti={false}
                    placeholder="سمت مورد نظر را انتخاب نمایید"
                    defaultOptions
                    defaultValue={this.state.form_data.record.Role !== null ? [{ label: this.state.form_data.record.Role.title, value: this.state.form_data.record.Role.object_id }] : null}
                    loadOptions={(inputValue,callback) => this.loadAffilationsOptions(inputValue,callback)}
                    onChange={e => {
                      this.state.form_data.record.Role = {
                        object_id: e.value,
                        title: e.label
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            {this.isNull(this.state.form_data.record.special_person_id) &&
              <div className="col-md-4">
                  <div className="form-group">
                  <p style={{"margin-top": "22px","padding-right": "5px"}}>اگر این فرد سازمانی، عضو هیات علمی دانشگاههای ایران می باشد، از لیست زیر انتخاب فرمایید:</p>
                    <label className="col-sm-12 control-label">دانشگاه</label>
                    <div className="col-sm-12">
                      <SelectAsync
                        isMulti={false}
                        placeholder="مرکز مورد نظر را انتخاب نمایید"
                        defaultOptions
                        defaultValue={this.state.form_data.record.Uni !== null ? [{ label: this.state.form_data.record.Uni.name, value: this.state.form_data.record.Uni.person_id }] : null}
                        loadOptions={(inputValue,callback) => this.loadUniversityOptions(inputValue,callback)}
                        onChange={e => {
                          this.state.form_data.record.Uni = {
                            person_id: e.value,
                            name: e.label
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    {!this.isBlank(this.state.form_data.record.pic) && !this.state.form_data.record.pic.includes("base64") &&
                      <div className="col-sm-12" style={{"text-align": "center"}}>
                        <img src={"/media/temp_organ/" + this.state.form_data.record.pic} style={{"width":"80px","height":"80px"}} />
                      </div>
                    }
                    <div className="col-sm-12">
                      <Uploader
                        withPreview={true}
                        withIcon={true}
                        withLabel={false}
                        buttonText='انتخاب عکس پروفایل'
                        fileSizeError="حجم فایل انتخابی زیاد است"
                        fileTypeError="فرمت فایل انتخابی نامعتبر است"
                        onChange={this.onDropPic}
                        imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg','.webp']}
                        singleImage={true}
                        maxFileSize={5242880}
                      />
                    </div>
                  </div>
              </div>
            }

            {this.state.remove === true ?
              <div className='col-md-12' style={{"margin-top": "30px"}}>
                <p>آیا با حذف این فرد از لیست افراد مهم موافق هستید؟</p>
                <button type="button" className="btn btn-danger" onClick={(e) => { this.remove(); }}>بله حذف شود</button>
                <button type="button" className="btn" onClick={(e) => { this.setState({remove: false}) }} style={{"float": "left"}}>خیر - برگشت</button>
              </div>
            :
              <div className='col-md-12' style={{"margin-top": "30px"}}>
                <button type="button" className="btn btn-success" onClick={(e) => { this.saveForm(''); }}>ذخیره</button>
                {(this.state.form_data.record.id > 0 ||this.state.form_data.record.special_person_id > 0 ) && <button type="button" className="btn btn-danger" onClick={(e) => { this.setState({remove: true}) }} style={{"float": "left"}}>حذف اطلاعات</button>}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    );
  }
  renderNormalView() {
    return (
      this.state.form_data.status === 4 ?
        this.renderNoLogin()
        :
        this.state.form_data.status === 2 ?
          this.renderNoAccess()
          :
          this.renderBody()
    );
  }
  render() {
    return (
      this.state.form_data === null || this.state.form_data === undefined ? null :
        this.renderNormalView()
    );
  }
}
const SpecialPersonEXP = withRouter(SpecialPerson);
export default SpecialPersonEXP;